import React from 'react';
import {JULY_FIRST, MARCH_FIRST, TODAY} from 'shared/utils';
import {EducationPhase} from '../../../../types/enums';

interface TextValues {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  footerText: string;
  lateSignup: boolean;
  lateSeniorSignup: boolean;
  disclaimer: string;
}

export default function getText(
  isXSView: boolean,
  firstName: string,
  isImpostor: boolean,
  hsGraduationYear: number,
  educationPhase: EducationPhase
): TextValues {
  let title: React.ReactNode = `Here are ${
    isImpostor ? `${firstName}'s` : 'your'
  } matches based on what
                ${isImpostor ? "they've" : "you've"} done!`;
  let subtitle: React.ReactNode = `Follow colleges to see how much ${
    isImpostor ? firstName : 'you'
  } could earn. Following colleges allows them to view your profile to track your progress and award you scholarships.`;
  const footerText = `Plus hundreds of more colleges ${
    isImpostor ? firstName : 'you'
  } can earn from when
          ${isImpostor ? 'they' : 'you'} get started!`;

  if (isXSView) {
    title = [
      `Here are ${isImpostor ? `${firstName}'s` : 'your'} matches based`,
      <br key="title-break" />,
      `on what ${isImpostor ? "they've" : "you've"} done!`,
    ];

    subtitle = [
      'Follow colleges to see how much',
      <br key="subtitle-break" />,
      `${isImpostor ? firstName : 'you'} could earn. Following colleges`,
      <br key="subtitle-break" />,
      'allows them to view your profile to track',
      <br key="subtitle-break" />,
      'your progress and award you scholarships.',
    ];
  }

  if (educationPhase === EducationPhase.COMMUNITY_COLLEGE) {
    title = 'Here are some colleges you might be interested in.';
  }

  const lateSeniorSignupTitle = `If ${
    isImpostor ? `${firstName}'s` : "you're"
  } still making college plans,
                                you can earn here!`;

  // @ts-expect-error
  const lateSignup = MARCH_FIRST < TODAY < JULY_FIRST;
  const isSeniorYear = hsGraduationYear === TODAY.getFullYear();
  const lateSeniorSignup =
    educationPhase === EducationPhase.HIGH_SCHOOL && lateSignup && isSeniorYear;

  return {
    subtitle,
    footerText,
    lateSignup,
    lateSeniorSignup,
    disclaimer:
      educationPhase === EducationPhase.COMMUNITY_COLLEGE
        ? ''
        : 'Total Potential Micro-Scholarships',
    title: lateSeniorSignup ? lateSeniorSignupTitle : title,
  };
}
